
/* injects from baggage-loader */

import React, { Component } from 'react';
import PropTypes from "prop-types";
import {t} from '../../../helpers/translator';

function Soccer ({ data }) {
    return (
        <div className="scores-info-g" key={data.id}>
            <ul>
                {
                    data.info && data.info.score1 ? <li className='soccer-block-height'><span className="active soccerChange">{t(`FM`)}</span><span className="active">{data.info.score1}</span><span className="active">{data.info.score2}</span></li>
                        : <li className='soccerChange'><span className="active">{t(`FM`)}</span><span className="active">-</span ><span>-</span></li>
                }
                {
                    data.stats.score_set1 ? <li className={`soccerChange ${data.info.current_game_state === "Half Time" || data.info.current_game_state === "set1" ? "active" : ''}`}><span >{t(`1H`)}</span><span>{data.stats.score_set1.team1_value}</span><span>{data.stats.score_set1.team2_value}</span></li>
                        : <li className="soccerChange"><span>{t(`1H`)}</span><span>-</span><span>-</span></li>
                }
                {
                    data.stats.score_set2 ? <li className={`soccerChange ${data.info.current_game_state === "Half Time" || data.info.current_game_state === "set2" ? "active" : ''}`}><span>{t(`2H`)}</span><span>{data.stats.score_set2.team1_value}</span><span>{data.stats.score_set2.team2_value}</span></li>
                        : <li className="soccerChange"><span>{t(`2H`)}</span><span>-</span><span>-</span></li>
                }
            </ul>
        </div>
    );
}
Soccer.propTypes = {
    data: PropTypes.object
};
function Basketball ({ data }) {
    return (
        <div className="scores-info-g" key={data.id}>
            <ul>
                {
                    data.info && data.info.score1 ? <li><span className="active">{t(`FM`)}</span><span className="active">{data.info.score1}</span><span className="active">{data.info.score2}</span></li> : null
                }
                {
                    data.stats.score_set4 ? <li className={`${data.info.current_game_state === "set4" ? "active" : ''}`}><span>{t(`4Q`)}</span><span >{data.stats.score_set4.team1_value}</span><span>{data.stats.score_set4.team2_value}</span></li> 
                        : <li><span>{t(`4Q`)}</span><span >-</span><span>-</span></li>
                }
                {
                    data.stats.score_set3 ? <li className={`${data.info.current_game_state === "set3" ? "active" : ''}`}><span>{t(`3Q`)}</span><span >{data.stats.score_set3.team1_value}</span><span>{data.stats.score_set3.team2_value}</span></li> 
                        : <li><span>{t(`3Q`)}</span><span >-</span><span>-</span></li>
                }
                {
                    data.stats.score_set2 ? <li className={`${data.info.current_game_state === "set2" ? "active" : ''}`}><span>{t(`2Q`)}</span><span >{data.stats.score_set2.team1_value}</span><span>{data.stats.score_set2.team2_value}</span></li> 
                        : <li><span>{t(`2Q`)}</span><span >-</span><span>-</span></li>
                }
                {
                    data.stats.score_set1 ? <li className={`${data.info.current_game_state === "set1" ? "active" : ''}`}><span>{t(`1Q`)}</span><span >{data.stats.score_set1.team1_value}</span><span>{data.stats.score_set1.team2_value}</span></li> 
                        : <li><span>{t(`1Q`)}</span><span >-</span><span>-</span></li>
                }
            </ul>
        </div>
    );
}
Basketball.propTypes = {
    data: PropTypes.object
};
function Tennis ({ data }) {
    return (
        <div className="scores-info-g" key={data.id}>
            <ul>
                {
                    data.info && data.info.score1 ? <li><span className="active">{t(`FM`)}</span><span className="active">{data.info.score1}</span><span className="active">{data.info.score2}</span></li> : null
                }
                {
                    data.stats.passes ? <li><span className="active">{t(`Points`)}</span><span className="active">{data.stats.passes.team1_value}</span><span className="active">{data.stats.passes.team2_value}</span></li> : null
                }
                {
                    data.stats.score_set4
                        ? data.stats.score_set5 ? <li className={`${data.info.current_game_state === "set5" ? "active" : ''}`}><span>{t(`5S`)}</span><span >{data.stats.score_set5.team1_value}</span><span>{data.stats.score_set5.team2_value}</span></li>
                            : <li><span>{t(`5S`)}</span><span >-</span><span>-</span></li>
                        : null
                }
                {
                    data.stats.score_set4
                        ? data.stats.score_set4 ? <li className={`${data.info.current_game_state === "set4" ? "active" : ''}`}><span>{t(`4S`)}</span><span >{data.stats.score_set4.team1_value}</span><span>{data.stats.score_set4.team2_value}</span></li> 
                            : <li><span>{t(`4S`)}</span><span >-</span><span>-</span></li>
                        : null
                }
                {
                    data.stats.score_set3 ? <li className={`${data.info.current_game_state === "set3" ? "active" : ''}`}><span>{t(`3S`)}</span><span >{data.stats.score_set3.team1_value}</span><span>{data.stats.score_set3.team2_value}</span></li> 
                        : <li><span>{t(`3S`)}</span><span >-</span><span>-</span></li>
                }
                {
                    data.stats.score_set2 ? <li className={`${data.info.current_game_state === "set2" ? "active" : ''}`}><span>{t(`2S`)}</span><span >{data.stats.score_set2.team1_value}</span><span>{data.stats.score_set2.team2_value}</span></li> 
                        : <li><span>{t(`2S`)}</span><span >-</span><span>-</span></li>
                }
                {
                    data.stats.score_set1 ? <li className={`${data.info.current_game_state === "set1" ? "active" : ''}`}><span>{t(`1S`)}</span><span >{data.stats.score_set1.team1_value}</span><span>{data.stats.score_set1.team2_value}</span></li> 
                        : <li><span>{t(`1S`)}</span><span >-</span><span>-</span></li>
                }
            </ul>
        </div>
    );
}
Tennis.propTypes = {
    data: PropTypes.object
};
function OtherSports ({ data }) {
    return (
        <div className="scores-info-g" key={data.id}>
            <ul>
                {
                    data.info && data.info.score1 ? <li><span className="active">{t(`FM`)}</span><span className="active">{data.info.score1}</span><span className="active">{data.info.score2}</span></li>
                        : null
                }
                {
                    data.stats && data.stats.score_set6 ? <li className={`${data.info.current_game_state === "set6" ? "active" : ''}`}><span>{t(`6S`)}</span><span >{data.stats.score_set6.team1_value}</span><span>{data.stats.score_set6.team2_value}</span></li>
                        : null
                }
                {
                    data.stats && data.stats.score_set5 ? <li className={`${data.info.current_game_state === "set5" ? "active" : ''}`}><span>{t(`5S`)}</span><span >{data.stats.score_set5.team1_value}</span><span>{data.stats.score_set5.team2_value}</span></li>
                        : null
                }
                {
                    data.stats && data.stats.score_set4 ? <li className={`${data.info.current_game_state === "set4" ? "active" : ''}`}><span>{t(`4S`)}</span><span >{data.stats.score_set4.team1_value}</span><span>{data.stats.score_set4.team2_value}</span></li>
                        : null
                }
                {
                    data.stats && data.stats.score_set3 ? <li className={`${data.info.current_game_state === "set3" ? "active" : ''}`}><span>{t(`3S`)}</span><span >{data.stats.score_set3.team1_value}</span><span>{data.stats.score_set3.team2_value}</span></li>
                        : null
                }
                {
                    data.stats && data.stats.score_set2 ? <li className={`${data.info.current_game_state === "set2" ? "active" : ''}`}><span>{t(`2S`)}</span><span >{data.stats.score_set2.team1_value}</span><span>{data.stats.score_set2.team2_value}</span></li>
                        : null
                }
                {
                    data.stats && data.stats.score_set1 ? <li className={`${data.info.current_game_state === "set1" ? "active" : ''}`}><span>{t(`1S`)}</span><span >{data.stats.score_set1.team1_value}</span><span>{data.stats.score_set1.team2_value}</span></li>
                        : null
                }
            </ul>
        </div>
    );
}
OtherSports.propTypes = {
    data: PropTypes.object
};
function Volleyball ({ data }) {
    return (
        <div className="scores-info-g" key={data.id}>
            <ul>
                {
                    data.info && data.info.score1 ? <li><span className="active">{t(`FM`)}</span><span className="active">{data.info.score1}</span><span className="active">{data.info.score2}</span></li> : null
                }
                {
                    data.stats.score_set5 ? <li className={`${data.info.current_game_state === "set5" ? "active" : ''}`}><span>{t(`5S`)}</span><span >{data.stats.score_set5.team1_value}</span><span>{data.stats.score_set5.team2_value}</span></li>
                        : <li><span>{t(`5S`)}</span><span >-</span><span>-</span></li>
                }
                {
                    data.stats.score_set4 ? <li className={`${data.info.current_game_state === "set4" ? "active" : ''}`}><span>{t(`4S`)}</span><span >{data.stats.score_set4.team1_value}</span><span>{data.stats.score_set4.team2_value}</span></li> 
                        : <li><span>{t(`4S`)}</span><span >-</span><span>-</span></li>
                }
                {
                    data.stats.score_set3 ? <li className={`${data.info.current_game_state === "set3" ? "active" : ''}`}><span>{t(`3S`)}</span><span >{data.stats.score_set3.team1_value}</span><span>{data.stats.score_set3.team2_value}</span></li> 
                        : <li><span>{t(`3S`)}</span><span >-</span><span>-</span></li>
                }
                {
                    data.stats.score_set2 ? <li className={`${data.info.current_game_state === "set2" ? "active" : ''}`}><span>{t(`2S`)}</span><span >{data.stats.score_set2.team1_value}</span><span>{data.stats.score_set2.team2_value}</span></li> 
                        : <li><span>{t(`2S`)}</span><span >-</span><span>-</span></li>
                }
                {
                    data.stats.score_set1 ? <li className={`${data.info.current_game_state === "set1" ? "active" : ''}`}><span>{t(`1S`)}</span><span >{data.stats.score_set1.team1_value}</span><span>{data.stats.score_set1.team2_value}</span></li> 
                        : <li><span>{t(`1S`)}</span><span >-</span><span>-</span></li>
                }
            </ul>
        </div>
    );
}
Volleyball.propTypes = {
    data: PropTypes.object
};
function IceHockey ({ data }) {
    return (
        <div className="scores-info-g" key={data.id}>
            <ul>
                {
                    data.info && data.info.score1 ? <li><span className="active">{t(`FM`)}</span><span className="active">{data.info.score1}</span><span className="active">{data.info.score2}</span></li> : null
                }
                {
                    data.stats.score_set3 ? <li className={`${data.info.current_game_state === "set3" ? "active" : ''}`}><span>{t(`3P`)}</span><span >{data.stats.score_set3.team1_value}</span><span>{data.stats.score_set3.team2_value}</span></li> 
                        : <li><span>{t(`3P`)}</span><span >-</span><span>-</span></li>
                }
                {
                    data.stats.score_set2 ? <li className={`${data.info.current_game_state === "set2" ? "active" : ''}`}><span>{t(`2P`)}</span><span >{data.stats.score_set2.team1_value}</span><span>{data.stats.score_set2.team2_value}</span></li> 
                        : <li><span>{t(`2P`)}</span><span >-</span><span>-</span></li>
                }
                {
                    data.stats.score_set1 ? <li className={`${data.info.current_game_state === "set1" ? "active" : ''}`}><span>{t(`1P`)}</span><span >{data.stats.score_set1.team1_value}</span><span>{data.stats.score_set1.team2_value}</span></li> 
                        : <li><span>{t(`1P`)}</span><span >-</span><span>-</span></li>
                }
            </ul>
        </div>
    );
}
IceHockey.propTypes = {
    data: PropTypes.object
};
function TableTennis ({ data }) {
    return (
        <div className="scores-info-g" key={data.id}>
            <ul>
                {
                    data.info && data.info.score1 ? <li><span className="active">{t(`FM`)}</span><span className="active">{data.info.score1}</span><span className="active">{data.info.score2}</span></li> : null
                }
                {
                    data.stats.score_set5 ? <li className={`${data.info.current_game_state === "set5" ? "active" : ''}`}><span>{t(`5S`)}</span><span >{data.stats.score_set5.team1_value}</span><span>{data.stats.score_set5.team2_value}</span></li>
                        : <li><span>{t(`5S`)}</span><span >-</span><span>-</span></li>
                }
                {
                    data.stats.score_set4 ? <li className={`${data.info.current_game_state === "set4" ? "active" : ''}`}><span>{t(`4S`)}</span><span >{data.stats.score_set4.team1_value}</span><span>{data.stats.score_set4.team2_value}</span></li> 
                        : <li><span>{t(`4S`)}</span><span >-</span><span>-</span></li>
                }
                {
                    data.stats.score_set3 ? <li className={`${data.info.current_game_state === "set3" ? "active" : ''}`}><span>{t(`3S`)}</span><span >{data.stats.score_set3.team1_value}</span><span>{data.stats.score_set3.team2_value}</span></li> 
                        : <li><span>{t(`3S`)}</span><span >-</span><span>-</span></li>
                }
                {
                    data.stats.score_set2 ? <li className={`${data.info.current_game_state === "set2" ? "active" : ''}`}><span>{t(`2S`)}</span><span >{data.stats.score_set2.team1_value}</span><span>{data.stats.score_set2.team2_value}</span></li> 
                        : <li><span>{t(`2S`)}</span><span >-</span><span>-</span></li>
                }
                {
                    data.stats.score_set1 ? <li className={`${data.info.current_game_state === "set1" ? "active" : ''}`}><span>{t(`1S`)}</span><span >{data.stats.score_set1.team1_value}</span><span>{data.stats.score_set1.team2_value}</span></li> 
                        : <li><span>{t(`1S`)}</span><span >-</span><span>-</span></li>
                }
            </ul>
        </div>
    );
}
TableTennis.propTypes = {
    data: PropTypes.object
};
function ETennis ({ data }) {
    return (
        <div className="scores-info-g" key={data.id}>
            <ul>
                {
                    data.info && data.info.score1 ? <li><span className="active">{t(`FM`)}</span><span className="active">{data.info.score1}</span><span className="active">{data.info.score2}</span></li> : null
                }
                {
                    data.stats.score_set4
                        ? data.stats.score_set5 ? <li className={`${data.info.current_game_state === "set5" ? "active" : ''}`}><span>{t(`5S`)}</span><span >{data.stats.score_set5.team1_value}</span><span>{data.stats.score_set5.team2_value}</span></li>
                            : <li><span>{t(`5S`)}</span><span >-</span><span>-</span></li>
                        : null
                }
                {
                    data.stats.score_set4
                        ? data.stats.score_set4 ? <li className={`${data.info.current_game_state === "set4" ? "active" : ''}`}><span>{t(`4S`)}</span><span >{data.stats.score_set4.team1_value}</span><span>{data.stats.score_set4.team2_value}</span></li> 
                            : <li><span>{t(`4S`)}</span><span >-</span><span>-</span></li>
                        : null
                }
                {
                    data.stats.score_set3 ? <li className={`${data.info.current_game_state === "set3" ? "active" : ''}`}><span>{t(`3S`)}</span><span >{data.stats.score_set3.team1_value}</span><span>{data.stats.score_set3.team2_value}</span></li> 
                        : <li><span>{t(`3S`)}</span><span >-</span><span>-</span></li>
                }
                {
                    data.stats.score_set2 ? <li className={`${data.info.current_game_state === "set2" ? "active" : ''}`}><span>{t(`2S`)}</span><span >{data.stats.score_set2.team1_value}</span><span>{data.stats.score_set2.team2_value}</span></li> 
                        : <li><span>{t(`2S`)}</span><span >-</span><span>-</span></li>
                }
                {
                    data.stats.score_set1 ? <li className={`${data.info.current_game_state === "set1" ? "active" : ''}`}><span>{t(`1S`)}</span><span >{data.stats.score_set1.team1_value}</span><span>{data.stats.score_set1.team2_value}</span></li> 
                        : <li><span>{t(`1S`)}</span><span >-</span><span>-</span></li>
                }
            </ul>
        </div>
    );
}
ETennis.propTypes = {
    data: PropTypes.object
};
class Scores extends Component {
    render () {
        switch (this.props.sportAlias) {
            case "Soccer":
                return <Soccer data = {this.props.game}/>;
            case "CyberFootball":
                return <Soccer data = {this.props.game}/>;
            case "Tennis":
                return <Tennis data = {this.props.game}/>;
            case "ETennis":
                return <ETennis data = {this.props.game}/>;
            case "Basketball":
                return <Basketball data = {this.props.game}/>;
            case "3x3 Basketball":
                return <Basketball data = {this.props.game}/>;
            case "EBasketball":
                return <Basketball data = {this.props.game}/>;
            case "Volleyball":
                return <Volleyball data = {this.props.game}/>;
            case "IceHockey":
                return <IceHockey data = {this.props.game}/>;
            case "TableTennis":
                return <TableTennis data = {this.props.game}/>;
            default:
                return <OtherSports data = {this.props.game}/>;
        }
    }
}
export default Scores;

Scores.propTypes = {
    sportAlias: PropTypes.string,
    game: PropTypes.object
};